import React from "react";
import { Eye } from "lucide-react";
import { ImagesAssets } from "../constants/ImagesAssets";
import { MockData } from "../data/mock";

import "./HomeHeroSection.css";

export const HomeHeroSection = ({ info }) => {
  const handleResumeClick = () => {
    window.open(
      "https://drive.google.com/file/d/1NIgGgvCXGgoV--m97CDtwNr4l2tuZ0tm/view?usp=drive_link",
      "_blank"
    );
  };

  return (
    <section className="hero-section">
      <div className="hero-grid-overlay"></div>

      <div className="hero-container">
        <div className="hero-left">
          <div className="hero-avatar">
            <div className="hero-avatar-border" />
            <div className="hero-avatar-inner">
              <img
                src={ImagesAssets.logo || "https://via.placeholder.com/290"}
                alt="Taim Hekmat Amer"
                draggable={false}
              />
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="hero-content">
            <div className="hero-top">
              <span>HELLO, MY NAME IS</span>
              <div className="hero-line" />
            </div>

            <h1 className="hero-name">Taim Hekmat Amer</h1>

            <div className="hero-title">{info?.title || "Flutter Developer"}</div>

            <p className="hero-description">
              {info?.bio ||
                "I build modern, scalable, and beautiful mobile applications using Flutter, clean architecture, APIs, and smooth user experiences."}
            </p>

            {/* تم ضبط alignItems هنا لتبدأ العناصر من اليمين في الديسكتوب وتتوسط في الموبايل عبر الـ CSS */}
            <div
              className="hero-actions-wrapper"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: "20px",
                marginTop: "24px",
                width: "100%",
              }}
            >
              {/* ROW 1: CONTACTS */}
              <div
                className="hero-contacts-row"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "18px",
                  flexWrap: "wrap",
                }}
              >
                {MockData.contacts?.map((contact, index) => (
                  <div
                    key={contact.id || index}
                    onClick={() =>
                      contact.link &&
                      window.open(
                        contact.link,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                    style={{
                      width: "68px",
                      height: "68px",
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(255, 255, 255, 0.05)",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      backdropFilter: "blur(8px)",
                      cursor: "pointer",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      overflow: "hidden",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background =
                        "rgba(255, 255, 255, 0.12)";
                      e.currentTarget.style.borderColor = "#60a5fa";
                      e.currentTarget.style.transform = "translateY(-4px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background =
                        "rgba(255, 255, 255, 0.05)";
                      e.currentTarget.style.borderColor =
                        "rgba(255, 255, 255, 0.1)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {contact.media?.url && (
                      <img
                        src={contact.media.url}
                        alt={contact.title || ""}
                        style={{
                          width: "36px",
                          height: "36px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>

              {/* ROW 2: RESUME BUTTON ALWAYS UNDER ICONS */}
              <button
                className="hero-button"
                onClick={handleResumeClick}
                style={{
                  margin: 0,
                  fontSize: "16px",
                  padding: "14px 28px",
                  borderRadius: "18px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Eye size={20} style={{ marginRight: "10px" }} />
                <span>My Resume</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
